module.exports = new __parcel__URL__("star-wars.344e4ba8.jpg").toString();